import ko from '@/locales/ko.json'
import zh from '@/locales/zh.json'
import ja from '@/locales/ja.json'
import en from '@/locales/en.json'

export default {
  'ko': ko,
  'zh': zh,
  'ja': ja,
  'en': en,
}